import { image } from 'd3-fetch';
import React,{useState,useEffect} from 'react';

const RoundProcessP2 = (props) => {
    const [color,setColor]= useState("#000000") ;
    
    useEffect(()=>{
        if(props.scoreP2RiskGrading){
            let colorT = "#000000";
            let scoreP2RiskGrading = props.scoreP2RiskGrading;
            
            if(scoreP2RiskGrading && scoreP2RiskGrading === "T1") {
                colorT = "#3ED68D";
            }
            else if(scoreP2RiskGrading && scoreP2RiskGrading === "T2") {
                colorT = "#ee964f";
            }
            else if(scoreP2RiskGrading && scoreP2RiskGrading !== "T1" && scoreP2RiskGrading !== "T2") {
                colorT = "#EE5C5C";
            }
            else {
                colorT = "#000000";
            }
            setColor(colorT)            
        }
    },[props.scoreP2RiskGrading])

    useEffect(()=>{
        if(props.scoreP3RiskGrading){
            let colorT = "#000000";
            let scoreP3RiskGrading = props.scoreP3RiskGrading;
            
            if(scoreP3RiskGrading && scoreP3RiskGrading === "T1") {
                colorT = "#3ED68D";
            }
            else if(scoreP3RiskGrading && (scoreP3RiskGrading === "T2" || scoreP3RiskGrading === "T3")) {
                colorT = "#ee964f";
            }
            else if(scoreP3RiskGrading && (scoreP3RiskGrading === "T4" || scoreP3RiskGrading === "T5")) {
                colorT = "#EE5C5C";
            }
            else {
                colorT = "#000000";
            }
            setColor(colorT)            
        }
    },[props.scoreP3RiskGrading])
    

    return(
        <div className="circleProgress" >
        <svg width={props.width} height={props.height} viewBox="0 0 75 77" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse opacity="0.05" cx="38.3217" cy="33.7346" rx="33.1142" ry="32.7956" fill="#6DD230" />
            <path fillRule="evenodd" clipRule="evenodd" d="M2.89111 35.0427C2.89111 53.725 18.5308 68.87 37.8234 68.87C57.1159 68.87 72.7557 53.725 72.7557 35.0427C72.7557 16.3603 57.1159 1.21533 37.8234 1.21533C18.5308 1.21533 2.89111 16.3603 2.89111 35.0427ZM71.2038 35.0434C71.2038 52.8954 56.2592 67.3673 37.8241 67.3673C19.3889 67.3673 4.44433 52.8954 4.44433 35.0434C4.44433 17.1914 19.3889 2.71948 37.8241 2.71948C56.2592 2.71948 71.2038 17.1914 71.2038 35.0434Z" fill={color}/>
            <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="2" y="1" width="71" height="68">
                <path fillRule="evenodd" clipRule="evenodd" d="M2.89111 35.0427C2.89111 53.725 18.5308 68.87 37.8234 68.87C57.1159 68.87 72.7557 53.725 72.7557 35.0427C72.7557 16.3603 57.1159 1.21533 37.8234 1.21533C18.5308 1.21533 2.89111 16.3603 2.89111 35.0427ZM71.2038 35.0434C71.2038 52.8954 56.2592 67.3673 37.8241 67.3673C19.3889 67.3673 4.44433 52.8954 4.44433 35.0434C4.44433 17.1914 19.3889 2.71948 37.8241 2.71948C56.2592 2.71948 71.2038 17.1914 71.2038 35.0434Z" fill="white" />
            </mask>
            <g mask="url(#mask0)">
                <path d="M65.7957 69.1747L38.2912 42.1167L4.55371 69.1747L65.7957 74.2221V72.0918V69.1747Z" fill="white" />
               
            </g>
            <text x={props.x+"%"} y={props.y+"%"} fill={'#4F565E'} style={{fontSize:"14.58px",textTransform: 'Capitalize'}} textAnchor="middle">{props.score || props.scoreP2 || props.data || "N/A"}</text>
            <rect x="0.691895" y="54.8696" width="73.7544" height="21.8637" fill="white"/>
                <circle cx="49%" cy="75%" r="11" fill={color}> </circle>
                {props.scoreP2RiskGrading || props.scoreP3RiskGrading ?
                <text x={props.mx} y="81%" height="18" width="18" fill="#fff" style={{fontSize: "13px"}}>{props.scoreP2RiskGrading || props.
                    scoreP3RiskGrading}</text>
                :
                <image href={props.imageSrc} x="38%" y="63%" height="18" width="18" />
                }
        </svg>
        </div>
    )
}

export default RoundProcessP2;


